/** Drop Notion's duplicate leading `# PageTitle` when it matches the page title. */
export function stripDuplicateLeadingH1(markdown: string, pageTitle: string): string {
  const normalizedTitle = pageTitle.trim().toLowerCase();
  if (!normalizedTitle) {
    return markdown;
  }

  const lines = markdown.split('\n');
  let i = 0;
  while (i < lines.length && lines[i]!.trim() === '') {
    i++;
  }
  if (i >= lines.length) {
    return markdown;
  }

  const h1Match = lines[i]!.match(/^#\s+(.+)$/);
  if (!h1Match) {
    return markdown;
  }

  const h1Title = h1Match[1]!.trim().toLowerCase();
  if (h1Title !== normalizedTitle) {
    return markdown;
  }

  i++;
  while (i < lines.length && lines[i]!.trim() === '') {
    i++;
  }

  return lines.slice(i).join('\n').trimStart();
}
